import { aftersaleCaseRoutes } from "./aftersales/case.routes.js";
import { disputeRoutes } from "./aftersales/dispute.routes.js";
import { bankAccountRoutes } from "./catalog/bank-account.routes.js";
import { categoryRoutes } from "./catalog/category.routes.js";
import { csRoutingRoutes } from "./catalog/cs-routing.routes.js";
import { opsModerationRoutes } from "./catalog/ops-moderation.routes.js";
import { productRoutes } from "./catalog/product.routes.js";
import { publicCatalogRoutes } from "./catalog/public.routes.js";
import { publishingRoutes } from "./catalog/publishing.routes.js";
import { searchRoutes } from "./catalog/search.routes.js";
import { shopRoutes } from "./catalog/shop.routes.js";
import { contactRoutes } from "./directory/contacts.routes.js";
import { directoryRoutes } from "./directory/directory.routes.js";
import { fileRoutes } from "./files/files.routes.js";
import { authRoutes } from "./identity/auth.routes.js";
import { enterpriseRoutes } from "./identity/enterprise.routes.js";
import { meRoutes } from "./identity/me.routes.js";
import { memberRoutes } from "./identity/member.routes.js";
import { opsSupportRoutes } from "./identity/ops-support.routes.js";
import { opsVerificationRoutes } from "./identity/ops-verification.routes.js";
import { planRoutes } from "./identity/plan.routes.js";
import { cardRoutes } from "./messaging/card.routes.js";
import { contactSellerRoutes } from "./messaging/contact-seller.routes.js";
import { contentAccessRoutes } from "./messaging/content-access.routes.js";
import { conversationRoutes } from "./messaging/conversation.routes.js";
import { inboxRoutes } from "./messaging/inbox.routes.js";
import { messageRoutes } from "./messaging/message.routes.js";
import { openimCallbackRoutes } from "./messaging/openim-callback.routes.js";
import { realtimeRoutes } from "./messaging/realtime.routes.js";
import { reportRoutes } from "./messaging/report.routes.js";
import { imSessionRoutes } from "./messaging/session.routes.js";
import { notificationRoutes } from "./notifications/notifications.routes.js";
import { auditRoutes } from "./operations/audit.routes.js";
import { configRoutes } from "./operations/config.routes.js";
import { operatorRoutes } from "./operations/operator.routes.js";
import { ledgerRoutes } from "./payment/ledger.routes.js";
import { payoutAccountRoutes } from "./payment/payout-account.routes.js";
import { systemRoutes } from "./system.routes.js";
import { changeOrderRoutes } from "./trade/change-order.routes.js";
import { inquiryRoutes } from "./trade/inquiry.routes.js";
import { invoiceRoutes } from "./trade/invoice.routes.js";
import { offlinePaymentRoutes } from "./trade/offline-payment.routes.js";
import { opsOrderRoutes } from "./trade/ops-order.routes.js";
import { orderRoutes } from "./trade/order.routes.js";
import { quoteRoutes } from "./trade/quote.routes.js";
import { referenceRateRoutes } from "./trade/reference-rate.routes.js";
import { reviewRoutes } from "./trade/review.routes.js";
import { shipmentRoutes } from "./trade/shipment.routes.js";
import { webhookRoutes } from "./webhook.routes.js";
/** Every route, in module order; each module card appends its own list. */
export const allRoutes = [
    ...systemRoutes,
    ...authRoutes,
    ...meRoutes,
    ...enterpriseRoutes,
    ...memberRoutes,
    ...directoryRoutes,
    ...contactRoutes,
    ...imSessionRoutes,
    ...conversationRoutes,
    ...contentAccessRoutes,
    ...cardRoutes,
    ...messageRoutes,
    ...inboxRoutes,
    ...realtimeRoutes,
    ...reportRoutes,
    ...categoryRoutes,
    ...shopRoutes,
    ...productRoutes,
    ...publishingRoutes,
    ...opsModerationRoutes,
    ...publicCatalogRoutes,
    ...searchRoutes,
    ...csRoutingRoutes,
    ...contactSellerRoutes,
    ...payoutAccountRoutes,
    ...operatorRoutes,
    ...opsVerificationRoutes,
    ...opsSupportRoutes,
    ...planRoutes,
    ...auditRoutes,
    ...configRoutes,
    ...referenceRateRoutes,
    ...inquiryRoutes,
    ...quoteRoutes,
    ...orderRoutes,
    ...opsOrderRoutes,
    ...offlinePaymentRoutes,
    ...shipmentRoutes,
    ...reviewRoutes,
    ...invoiceRoutes,
    ...changeOrderRoutes,
    ...aftersaleCaseRoutes,
    ...disputeRoutes,
    ...bankAccountRoutes,
    ...ledgerRoutes,
    ...fileRoutes,
    ...notificationRoutes,
    ...webhookRoutes,
    ...openimCallbackRoutes,
];
//# sourceMappingURL=routes.js.map